// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__J8gSj","socialIcon":"Footer_socialIcon__m7OF1"};